var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"card"},[_c('SnackbarPrompt',{attrs:{"icon":"warning","variation":"warning"}},[_vm._v(_vm._s(_vm.errorMessage))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }